import { SingleSpaCustomEventDetail } from 'single-spa';
import { hide } from '../api';

type SingleSpaEvent = Event & {
    detail: SingleSpaCustomEventDetail;
};

const onBeforeRoutingEvent = async ({ detail }: SingleSpaEvent) => {
    const { newUrl } = detail;
    const { pathname: newPath } = new URL(newUrl);

    if (newPath.startsWith('/partners')) {
        await hide();
    }
};

const hideSdkOnAppChange = async ({ detail }: SingleSpaEvent) => {
    if (detail.totalAppChanges > 0) {
        await hide();
    }
};

const registerToSingleSPAEvents = (shouldHideSdkOnAppChange: boolean) => {
    window.addEventListener('single-spa:before-routing-event', {
        handleEvent: () => onBeforeRoutingEvent,
    });

    if (shouldHideSdkOnAppChange) {
        window.addEventListener('single-spa:app-change', {
            handleEvent: () => hideSdkOnAppChange,
        });
    }
};

export default registerToSingleSPAEvents;
